import styled from 'styled-components';
export const SupplierContainer = styled.div`
  box-shadow: 4px -4px 8px rgba(4, 15, 15, 0.12);
  overflow: visible;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);
  padding-block: 16px;
`;
